import { navigationRoutes } from "@/core/routes/routes/modules/admin";
import { FC, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Button from "../common/button";
import PageCreatePanelWrapper from "../creator/page-create-panel-wrapper";
import { deleteBook, getBookDetailById, getUserDraftList, publishBook } from "@/core/requests/book";
import { BookModel } from "@/types/book";
import { ArrowLeftEndOnRectangleIcon, ArrowRightEndOnRectangleIcon, ArrowUpOnSquareIcon, ClockIcon, EyeIcon, PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import bookCreatorProvider from "@/core/providers/book-creator";
import IconButton from "../common/icon-button";
import { toastError, toastSuccess } from "@/core/utils/notification";
import DataEmpty from "../common/data-empty";
import DataEmptyBox from "../common/data-empty-box";
import { observer } from "mobx-react";
import adminIndex from "@/core/providers/admin-index";
import { useLogout } from "@/core/hooks/login";
import { checkIsSuperAdmin } from "@/core/requests/super-admin";

const AdminSlider = () => {
    return <div className="w-[300px] flex h-full">
        <div className="p-4 border-r border-info">
            <NavList />
        </div>
        <div className="flex-1 p-4">
            <ToolBar />
        </div>
    </div>
}


const ToolBar = () => {
    const navigate = useNavigate();
    const handleToCreate = () => {
        navigate("/creator");
    }
    return <div className="w-full h-full flex flex-col justify-between">
        <div>
            <Button onClick={handleToCreate} className="w-full">新的创作</Button>
        </div>
        <div className="flex-1 w-full relative h-full">
            <DraftList />
        </div>
    </div>
}


// 草稿箱
const DraftList = observer(() => {
    // const [draftList, setDraftList] = useState<Array<BookModel>>([]);
    const draftList = adminIndex.draftList;
    useEffect(() => {
        fetchDraftList();
    }, []);

    const fetchDraftList = async () => {
        adminIndex.fetchDraftList();
    }

    const handleReFetchPublishedList = () => {
        adminIndex.fetchPublishedList();
    }

    // 删除暂存箱内的书
    const fetchDeleteBook = async (model: BookModel) => {
        const id = model.id;
        const res = await deleteBook(id);
        if (res?.success) {
            toastSuccess(res?.message);
            fetchDraftList();
        } else {
            toastError(res?.message);
        }
        console.log(res);
    }

    // 发布
    const fetchPublishBook = async (model: BookModel) => {
        const id = model.id;
        const res = await publishBook(id);
        if (res?.success) {
            toastSuccess(res?.message);
            fetchDraftList();
            handleReFetchPublishedList();
        } else {
            toastError(res?.message);
        }
    }

    return <div className="w-full text-start h-full overflow-y-scroll max-h-full">
        <div className="bg-background dark:bg-dark-background sticky top-0 left-0 z-50 py-4  ">
            <h1 className="text-text text-md font-bold dark:text-dark-text ">暂存箱</h1>
        </div>
        <div className=" last:border-none pb-4 box-border">{draftList.map(_ => {
            return <DraftItem model={_} handleDelete={() => {
                fetchDeleteBook(_);
            }} handlePublish={() => {
                fetchPublishBook(_)
            }} />
        })}</div>
        {
            (draftList.length === 0) && <DataEmptyBox />
        }
    </div>
})

const DraftItem: FC<{
    model: BookModel,
    handleDelete: VoidFunction,
    handlePublish: VoidFunction
}> = ({ model, handleDelete, handlePublish }) => {
    const navigate = useNavigate();

    const fetchBookDetail = async () => {
        const id = model.id;
        const res = await getBookDetailById(id);
        if (res) {
            bookCreatorProvider.applyBook(model, res);
            console.log("编辑", model)
            navigate(`/creator`, {
                state: {
                    id: model.id,
                },
            });
        }
        console.log(res);
    }




    return <div className="py-4 border-b border-border w-full">
        <div className="flex  cursor-pointer bg-white dark:bg-black relative rounded-md overflow-hidden">
            <div className="relative flex-1">
                <div className="w-full">
                    <img src={`${model.cover}`} alt={model.cover} className="w-full" />
                </div>
                <div className="absolute bottom-0 bg-black/20 w-full left-0 p-1 flex justify-between">
                    <div>
                        <h1 className="text-sm text-dark-text dark:text-dark-text font-bold line-clamp-1">{model.title}</h1>
                        <h1 className="text-sm text-dark-text dark:text-dark-text flex items-center">
                            <ClockIcon className="size-4" />
                            {model.update_date}
                        </h1>
                    </div>
                </div>
            </div>
            <div className="border-l border-border flex flex-col">
                <IconButton
                    size={4} className=" dark:text-dark-text" onClick={() => {
                        handlePublish()
                    }}>
                    <ArrowUpOnSquareIcon />
                </IconButton>
                <IconButton size={4} className=" dark:text-dark-text"
                    onClick={() => {
                        // navigate(`/creator`);
                        fetchBookDetail();
                    }}>
                    <PencilSquareIcon />
                </IconButton>
                <IconButton size={4} className=" dark:text-dark-text" onClick={() => {
                    handleDelete();
                }}>
                    <TrashIcon />
                </IconButton>
            </div>
        </div>
    </div>
}


const NavList = () => {
    const navigates = useRef(navigationRoutes);
    //超级管理员
    const [role, setRole] = useState<Role>("user");
    const [activeNavigation, setActiveNavigation] = useState(navigates.current?.[0]);
    const navigate = useNavigate();
    const location=useLocation();
    const logout = useLogout();
    const handleActive = (route: NavigationRouteObject) => {
        if (!route?.path) return;
        navigate(route?.active_path ?? route.path);
    }

    useEffect(() => {
        fetchCheckSuperPermission();
    }, [])

    useEffect(() => {
       const route=navigationRoutes.find((_)=>{
        return (_.active_path??_.path)===location.pathname
       });
       if(route){
            setActiveNavigation(route);
       }
    }, [location])


    const fetchCheckSuperPermission = async () => {
        const res = await checkIsSuperAdmin();
        if (res) {
            setRole(res)
        }
    }

    /**
     * 权限拦截函数，用户给予任何访问权限
     * 如果所需权限为空，则除用户外的所有权限角色都可访问
     */
    const allowed_role=(role:Role,needs_role:Nullable<Array<Role>|Role>):boolean=>{
        if(role==="user")return false;
        if(!needs_role)return true;
        if(needs_role instanceof Array){
            return needs_role.includes(role);
        }else{
            return role===needs_role;
        }
    }

    return <div className="w-full h-full flex flex-col justify-between">
        <div className="w-full h-full flex flex-col">
            {
                navigates.current.map((_, ndx) => {
                     if (allowed_role(role,_.role)) return <div key={ndx} onClick={() => {
                        handleActive(_);
                    }}>
                        <NavigateItem model={_} active={activeNavigation?.name === _?.name} />
                    </div>
                    return <span key={ndx}></span>;
                })
            }
        </div>
        <div>
            <IconButton onClick={() => {
                logout();
                navigate("/login");
            }}>
                <ArrowLeftEndOnRectangleIcon />
            </IconButton>
        </div>
    </div>
}

const NavigateItem: FC<{
    model: NavigationRouteObject,
    active: boolean,
}> = ({ model, active }) => {
    return <div className="text-center cursor-pointer mb-6">
        <div className={`rounded-md  hover:bg-primary/50 p-2  hover:text-white  ${active ? 'bg-primary/50 text-white' : 'bg-transparent text-primary'}`}>
            <div className="size-6">
                {active ? model.active : model.icon}
            </div>
        </div>
        <span className="text-[.7rem] text-primary">{model?.name}</span>
    </div>
}

export default AdminSlider;